/**
 * @name BulkOrderPLP_DynamicTables.CategoryCollection.View.js
 *
 * @author Anchor Group : Tony Dittus <adittus@anchorgroup.tech>
 * 
 * @since 2024-02-29
 * 
 * @file Container View for the Headers and Item Collection Section
 */

define('BulkOrderPLP_DynamicTables.CategoryCollection.View',
    [
        'bulkorderplp_dynamictables_categorycollection.tpl',
        'Backbone',
        'Backbone.CollectionView',
        'BulkOrderPLP_DynamicTables.ItemLines.View'
    ],
    function (
        bulkorderplp_dynamictables_categorycollection_tpl,
        Backbone,
        BackboneCollectionView,
        BulkOrderPLP_DynamicTablesItemLinesView
    ) {
        'use strict';

        return Backbone.View.extend({
            template: bulkorderplp_dynamictables_categorycollection_tpl,

            initialize: function (options) {
                this.CartComponent = options.CartComponent;
                this.application = options.application;
                this.LayoutComponent = options.LayoutComponent;
                this.hidePricing = options.hidePricing;

                this.sectionCollection = new Backbone.Collection(_.toArray(this.model.attributes));

                this.headerModel = this.sectionCollection.findWhere({
                    isHeader: true
                });

                this.sectionCollection.remove(this.headerModel);

                //* Process header custom columns
                let configObj = this.headerModel.get('configObj');
                this.customColumnDisplayArray = new Array;
                for (let i = 1; i < 11; i++) {
                    this.customColumnDisplayArray.push({
                        columnItemID: configObj['customColumnFieldID' + i],
                        customColumnHeader: configObj['customColumnHeader' + i]
                    })
                }
            },

            events: {
                'change [data-action="selectAllInCategory"]': 'selectAllInCategory',
                'click [data-action="clearAllSelections"]': 'clearAllSelections',
                'click [data-action="addSelectedItemsToCart"]': 'addSelectedItemsToCart',
            },

            /**
             * Selects/unselects all the items in a category on selection of a header
             * @function  selectAllInCategory
             */
            selectAllInCategory: function (e) {
                $("[data-action='programmaticSelection'][data-category-section-index='" + e.currentTarget.dataset.categorySectionIndex + "']").prop("checked", e.currentTarget.checked);
            },

            /**
             * Clears all item selections
             * @function  clearAllSelections
             */
            clearAllSelections: function (e) {
                $("[data-action='selectAllInCategory']").prop("checked", false);
                $("[data-action='programmaticSelection']").prop("checked", false);
            },

            /**
             * Adds all currently selected items to the cart and shows the mini cart as confirmation
             * @function  addSelectedItemsToCart
             */
            addSelectedItemsToCart: _.debounce(function (e) {
                let allSelectedIDs = _.pluck($("[data-action='programmaticSelection']:checked"), 'value');

                let self = this;
                let linesToBeAddedToCart = new Array;
                _.filter(allSelectedIDs, function (itemID) {
                    let itemQty = JSON.parse($('#quantity-' + itemID).val());

                    if (itemQty > 0) {
                        linesToBeAddedToCart.push({
                            quantity: itemQty,
                            item: {
                                internalid: itemID,
                            }
                        });
                    }
                });

                if (linesToBeAddedToCart.length > 0) {
                    SC.loadingIndicatorShow();
                    this.CartComponent.addLines({
                        lines: linesToBeAddedToCart
                    }).then(function () {
                        SC.loadingIndicatorHide();
                        const Layout = self.application.getLayout();
                        $(document).scrollTop(0);
                        if (Layout.headerViewInstance) {
                            Layout.headerViewInstance.showMiniCart();
                        }
                    });
                }
            }, 300),

            childViews: {
                'BulkOrder.ItemsSection.Collection': function () {
                    return new BackboneCollectionView({
                        collection: this.sectionCollection,
                        childView: BulkOrderPLP_DynamicTablesItemLinesView,
                        childViewOptions: {
                            CartComponent: this.CartComponent,
                            application: this.application,
                            LayoutComponent: this.LayoutComponent,
                            hidePricing: this.hidePricing
                        }
                    });
                }
            },

            getContext: function getContext() {
                return {
                    headerModel: this.headerModel,
                    customColumnDisplayArray: this.customColumnDisplayArray
                };
            }
        });
    });
